import type { SVGProps } from 'react';

export interface PictureAvailableIconProps extends Omit<SVGProps<SVGSVGElement>, 'xmlns' | 'children'> {}

const PictureAvailableIcon = ({
  className,
  width = '20',
  height = '20',
  ...rest
}: PictureAvailableIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    {...rest}
    width={width}
    height={height}
    className={className}
    fill="none"
    aria-hidden={true}
    focusable="false"
  >
    <rect width="20" height="20" rx="10" fill="#3F6578" />
    <path
      d="M12.3837 6.25L11.795 5.48667C11.6777 5.33575 11.5276 5.21351 11.3561 5.12919C11.1846 5.04487 10.9961 5.00069 10.805 5H9.195C9.00387 5.00069 8.81541 5.04487 8.64389 5.12919C8.47237 5.21351 8.32228 5.33575 8.205 5.48667L7.61625 6.25H12.3837Z"
      fill="white"
    />
    <path
      d="M12.9167 7.08333H7.08333C6.531 7.084 6.00148 7.3037 5.61092 7.69426C5.22037 8.08482 5.00066 8.61434 5 9.16667V12.9167C5.00066 13.469 5.22037 13.9985 5.61092 14.3891C6.00148 14.7796 6.531 14.9993 7.08333 15H12.9167C13.469 14.9993 13.9985 14.7796 14.3891 14.3891C14.7796 13.9985 14.9993 13.469 15 12.9167V9.16667C14.9993 8.61434 14.7796 8.08482 14.3891 7.69426C13.9985 7.3037 13.469 7.084 12.9167 7.08333ZM10 13.3333C9.50555 13.3333 9.0222 13.1867 8.61107 12.912C8.19995 12.6373 7.87952 12.2469 7.6903 11.79C7.50108 11.3332 7.45157 10.8306 7.54804 10.3456C7.6445 9.86065 7.8826 9.4152 8.23223 9.06557C8.58186 8.71593 9.02732 8.47783 9.51227 8.38137C9.99723 8.28491 10.4999 8.33442 10.9567 8.52363C11.4135 8.71285 11.804 9.03328 12.0787 9.44441C12.3534 9.85553 12.5 10.3389 12.5 10.8333C12.4993 11.4962 12.2357 12.1317 11.767 12.6004C11.2983 13.0691 10.6628 13.3327 10 13.3333Z"
      fill="white"
    />
    <path
      d="M10 12.5C10.9205 12.5 11.6667 11.7538 11.6667 10.8333C11.6667 9.91286 10.9205 9.16667 10 9.16667C9.07953 9.16667 8.33333 9.91286 8.33333 10.8333C8.33333 11.7538 9.07953 12.5 10 12.5Z"
      fill="white"
    />
  </svg>
);

export default PictureAvailableIcon;
